import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';
import { useImageJob } from 'src/app/pages/startAPetitionV2/shared/hooks';

type UsePreviewReturn = ModelHookResult<
	{
		ask: string;
		jobStatus: 'idle' | 'pending' | 'error' | 'success';
		imageSrc?: string;
		description: string;
	},
	{ back: () => void; submit: () => void }
>;
export function usePreview(): UsePreviewReturn {
	const { data, actions } = useStartAPetitionPageState();
	const track = useTracking();

	const { status } = useImageJob({ enabled: true });

	const back = useCallback(() => {
		void track('sap_preview_back');

		actions.send({ type: 'back' });
	}, [actions, track]);

	const submit = useCallback(() => {
		void track('sap_preview_submit');

		actions.send({ type: 'submit' });
	}, [actions, track]);

	return {
		data: {
			ask: data.draft?.petitionDraft?.ask ?? '',
			description: data.draft?.petitionDraft?.description ?? '',
			jobStatus: status,
			imageSrc: data.draft?.petitionDraft?.image?.url,
		},
		actions: { back, submit },
	};
}
